import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { useEffect, useRef } from 'react';
import { useMappingService, useTrackingService } from './serviceHooks';

export const useCategoryViewTracker = (
    listId: string | undefined,
    request: IRequestContext,
    telemetry: ITelemetry,
    alreadyPrefixed?: boolean
) => {
    const lastTrackedListRef = useRef<string | undefined>();

    const relewiseTrackingService = useTrackingService(request, telemetry);
    const relewiseMappingService = useMappingService(request, telemetry);

    useEffect(() => {
        if (!listId || lastTrackedListRef.current === listId) {
            return;
        }

        const idToTrack = alreadyPrefixed ? listId : relewiseMappingService.prefixId(listId);
        relewiseTrackingService.trackCategoryView(idToTrack);
        lastTrackedListRef.current = listId;
    }, [listId, relewiseTrackingService, relewiseMappingService, alreadyPrefixed]);
};
